export enum CollectorId {
  DesktopCollector = 'b8e81a8a71b044a18764475335f4bc7d'
}

export enum SettingId {
  EnableScreentime = 'enable-screentime',
  EnableAppTracking = 'enable-app-tracking',
  LastModified = 'last-modified',
  Enabled = 'enabled'
}
